import axios from 'axios';
import { handleResponse } from '../helpers/handleResponse';
import { authHeader } from '../services/authHeader';


export const shippingService = {

    sync,
    syncStatus,
    getSyncJob,
    syncShippingLabels,
    getSingleSyncJob
};

function sync(){
    return axios({
        method: 'get',
        url: '/api/shipping-meta/variants/all',
        headers: authHeader()
    }).then(handleResponse);
}
function getSyncJob(){
  return axios({
      method: 'get',
      url: '/api/shipping-meta/variants/all/getStatus',
      headers: authHeader()
  }).then(handleResponse);
}
function syncStatus(id: any) {
  const source = new EventSource(`/api/shipping-meta/variants/all/status?clientId=${id}`);

  source.addEventListener('syncUpdate', (event) => {
    console.log('sync_update', event);
  });

  source.onmessage = e => {
    console.log('on message', e);
  }
  source.onerror = () => {
    // error log here
    console.log('on error');
    source.close();
  }

}
function syncShippingLabels(id: string, handle: string){
  return axios({
      method: 'get',
      url: `/api/shipping-meta/variants/sync/${handle}`,
      headers: authHeader()
  }).then(handleResponse);
}
function getSingleSyncJob(){
  return axios({
      method: 'get',
      url: "/api/shipping-meta/variants/syncStatus",
      headers: authHeader()
  }).then(handleResponse);
}